import Table from '@/components/Table/Table.jsx'
import TableChooseComponent from '../_COMPONENT/TableChooseExternalComponent.jsx'

export default function TableChooseUc(props) {
    const columns = [
        {
            title: '集成用例代码',
            dataIndex: 'sfNo',
            component: <Table.ViewText />,
        },

        {
            title: '集成用例名称',
            dataIndex: 'sfName',
            component: <Table.ViewText />,
        },

        {
            title: '业务需求单编号',
            dataIndex: 'reqNo',
            component: <Table.ViewText />,
        },
    ]

    return (
        <TableChooseComponent
            columns={columns}
            rowKey="pkid"
            {...props}
        />
    )
}
